module.exports = __webpack_public_path__ + "static/media/default.78b8581f.jpeg";